import { UsersRound } from "lucide-react";
import { useAuthStore } from "@/store/auth";
import { Button } from "@/components/ui/button";

export function NoActiveTeamPage() {
  const logout = useAuthStore((state) => state.logout);
  return (
    <div className="flex min-h-dvh items-center justify-center bg-studio-bg p-4">
      <div className="max-w-md rounded-2xl border border-studio-border bg-studio-panel p-6 text-center shadow-panel">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-studio-accent-soft text-studio-accent"><UsersRound className="h-6 w-6" /></span>
        <h1 className="mt-4 text-wrap-balance text-xl font-semibold text-studio-ink">No active team</h1>
        <p className="mt-2 text-sm leading-6 text-studio-muted">Your account is active, but it is not assigned to an active team. Ask an administrator to add you to a team.</p>
        <Button className="mt-5" variant="secondary" onClick={logout}>Return to login</Button>
      </div>
    </div>
  );
}
